import { IBusinessState, createSelector, createAsyncSelector } from '../../../flux';


const selectAsyncTenantEntities = createAsyncSelector({
	get: state => state.$business.counterparty.tenantEntities,
	selector: createSelector(
		(state: IBusinessState) => state.$business.counterparty.tenantEntities.item,
		item => item,
	),
});

const selectTenantEntitiesList = createSelector(
	selectAsyncTenantEntities.selectItem,
	item => item ? Object.keys(item).map(key => item[key]) : []
);

export const counterpartySelectorsPack = {
	selectAsyncTenantEntities,
	selectTenantEntitiesList,
};
